import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserTakeOverModal } from './UserTakeOverModal';

type Props = {
  Editable: boolean;
};

function UserTakeover({ Editable }: Props) {
  const [openTakeUserModal, setOpenTakeUserModal] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <>
      <a
        href="#user"
        onClick={() => setOpenTakeUserModal(true)}
        style={{
          color: Editable ? '' : '#9d9d9d',
          cursor: Editable ? 'pointer' : 'default',
        }}
      >
        <i
          className="fa-solid fa-people-arrows"
          style={{
            color: Editable ? '' : '#9d9d9d',
            cursor: Editable ? 'pointer' : 'default',
          }}
        />
        {t('ユーザー引継ぎ')}
      </a>
      <UserTakeOverModal open={openTakeUserModal} onClose={() => setOpenTakeUserModal(false)} />
    </>
  );
}

export { UserTakeover };
